import { createApp } from '@backstage/frontend-defaults';
import { gitlabAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import { navModule } from './modules/nav';

const appAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: {
        loader: async () => props => (
          <SignInPage
            {...props}
            auto
            provider={{
              id: 'gitlab-auth-provider',
              title: 'GitLab',
              message: 'Sign in with your HealthGo GitLab account',
              apiRef: gitlabAuthApiRef,
            }}
          />
        ),
      },
    }),
  ],
});

export default createApp({
  features: [
    catalogPlugin,
    kubernetesPlugin,
    navModule,
    appAuthModule,
  ],
});
